<template lang="html">
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" min-width="56" text class="px-2 py-3" style="height: auto !important;" v-bind="attrs" v-on="on">
        <div class="d-flex">
          <v-img :src="getImgUrl(locale)" width="24" height="16" />
          <v-icon size="16" color="#767676" class="ml-1">
            mdi-chevron-down
          </v-icon>
        </div>
      </v-btn>
    </template>
    <v-list class="list-locale">
      <v-list-item v-for="item in availableLocales" :key="item" @click="changeLocale(item)">
        <v-list-item-avatar tile width="24" height="24" min-width="24">
          <v-img width="24" height="24" contain :src="getImgUrl(item)" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-14">
            {{ item === 'id' ? 'Indonesia' : 'English' }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { setLocale } from '@/utils/locale'
export default {
  name: 'Locale',
  computed: {
    availableLocales() {
      return this.$i18n.availableLocales.filter(i => i.code !== this.$i18n.locale)
    },
    locale() {
      return this.$i18n.locale
    }
  },
  methods: {
    getImgUrl(img) {
      const images = require.context('@/assets/images/flags/', false, /\.png$/)
      return images('./' + img + '.png')
    },
    changeLocale(locale) {
      this.$i18n.locale = locale
      setLocale(locale)
      this.$router.go()
    }
  }
}
</script>
<style>
  .list-locale{
    padding: 0px;
  }
</style>
